<template>
  <div class="content">
    <div class="accountCon">
      <div style="color: #666;background-color: #f5f7fa;padding: 10px;font-size: 12px;line-height: 16px;">
        <div> 搜索条件：{{detail.remark}}</div>
       
      </div>
      <div class="btnBox">
        <el-button
          type="primary"
          class="mb10"
          size="mini"
          @click="getExport()"
        >导出数据</el-button>
      </div>
      <!--列表-->
      <el-row>
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            v-loading="loading"
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
            row-key="id"
            default-expand-all
            :tree-props="{children: 'kingdee_goods', hasChildren: 'hasChildren'}"
          >
            <ElTableColumn label="录入时间" width="150" prop="create_time"  fixed="left" v-if="search.kingdee_code.length == 0"/>
            <ElTableColumn label="姓名" prop="customer_name" width="100"  fixed="left"/>
            <ElTableColumn label="联系电话" prop="telephone" width="100" fixed="left"/>
            <ElTableColumn label="性别" width="50" prop="sex" />
            <ElTableColumn label="年龄" width="50" prop="age" v-if="search.kingdee_code.length == 0" />
            <ElTableColumn label="生日" prop="birthday" width="100" v-if="search.kingdee_code.length == 0" />
            <ElTableColumn label="来源" width="120" v-if="search.kingdee_code.length == 0">
              <template slot-scope="{ row }">
                {{row.source_name}}
                <span v-if="row.source_type_id > 0">--{{row.customer_source_name}}</span>
              </template>
            </ElTableColumn>
            <ElTableColumn label="是否进店" width="70" prop="effective_entry" v-if="search.kingdee_code.length == 0" />
            <ElTableColumn label="会员等级" prop="grade_name" v-if="search.kingdee_code.length == 0" />
            <ElTableColumn label="疑难级别(级)" prop="difficulty_level" v-if="search.kingdee_code.length == 0" />
            <ElTableColumn label="护理师" prop="nurse_name" v-if="search.kingdee_code.length == 0" />
            <ElTableColumn label="客服" width="70" prop="customer_service_name" />
            <ElTableColumn label="客户分类"  v-if="search.kingdee_code.length == 0"> 
              <template slot-scope="{ row }">
                {{row.class_name ? row.class_name + '类' : '-'}}
              </template>
            </ElTableColumn>

            <ElTableColumn label="转介绍人" prop="introducer_name"  v-if="search.kingdee_code.length == 0"/>
            <ElTableColumn label="门店/门诊" prop="shop_name" width="150" />
            <ElTableColumn label="K3码" prop="king_no" v-if="search.kingdee_code.length == 0" />
            <ElTableColumn label="修复进展" prop="progress_name" v-if="search.kingdee_code.length == 0" />
            <ElTableColumn label="疤痕类型" width="170" prop="scar_aggregate" v-if="search.kingdee_code.length == 0" />
            <ElTableColumn label="消费金额" prop="sum_money"  v-if="search.kingdee_code.length == 0"/>
            <ElTableColumn label="消费总金额" prop="consume_amount"  v-if="search.kingdee_code.length == 0"/>
            <ElTableColumn label="成交日期" prop="deal_time" width="90" v-if="search.kingdee_code.length != 0" />
            <ElTableColumn label="商品名称" prop="goods_name" width="100" v-if="search.kingdee_code.length != 0" />
            <ElTableColumn label="别名商品名称" prop="goods_alias_name" v-if="search.kingdee_code.length != 0" />
            <ElTableColumn label="数量" prop="number"  width="70" v-if="search.kingdee_code.length != 0" />
            <ElTableColumn label="销售单价" prop="pay_price"  width="70" v-if="search.kingdee_code.length != 0" />
            <ElTableColumn label="销售金额" prop="sales_amount"  width="70" v-if="search.kingdee_code.length != 0" />
            <ElTableColumn label="销售本金" prop="pay_amount"  width="70" v-if="search.kingdee_code.length != 0" />
            <ElTableColumn label="销售赠金" prop="gift_amount"  width="70" v-if="search.kingdee_code.length != 0" />
            <ElTableColumn label="销售店转" prop="shop_transfer_amount"  width="70" v-if="search.kingdee_code.length != 0" />
            <ElTableColumn label="开单人" prop="operator_id"  width="70" v-if="search.kingdee_code.length != 0" />
            <ElTableColumn label="是否存货" prop="prestock_type_name"  width="70" v-if="search.kingdee_code.length != 0" />
            <ElTableColumn label="开卡次数" prop="service_number" width="70" v-if="search.kingdee_code.length != 0" />
            <ElTableColumn label="到期时间" prop="end_time" v-if="search.kingdee_code.length != 0" />

            <ElTableColumn label="操作" fixed="right">
              <template slot-scope="{ row }" v-if="!row.kingdee_code">
                <span class="theme" @click="tapBtn('客户详情',row)">查 看</span>
              </template>
            </ElTableColumn>
          </el-table>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.limit"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import pagination from "@/components/Pagination";
import {
  clientList1,
  clientExport1,
  getSearchGroupDetail,
} from "@/api/client";


class Page {
  total = 0;
  page = 1;
  limit = 10;
}
export default {
  name: "ClientList",
  components: {
    pagination
  },
  data() {
    return {
      detail: {},
      search: '',
      idList: [],
      page: new Page(),
      list: [],
      loading: false,

    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {
    console.log(this.$route.query,"222")
      this.search = this.$route.query.search_content;
      this.getSearchGroupDetail();
  },
  methods: {
    // 筛选组详情
    getSearchGroupDetail() {
      getSearchGroupDetail({
        id: this.$route.query.id
      }).then(res => {
        this.detail = res;
        this.search = res.search_content;
        this.getList("search");
      });
    },
    // 获取列表
    getList(option) {
      this.loading = true;
      if (option === "search") this.page = new Page();
      clientList1({ ...this.search, ...this.page,search_id:this.$route.query.id,admin_id:this.userInfo.id }).then(
        res => {
          this.list = res.list;
          console.log(res,"eee")
          this.page.total = res.dataCount;
          this.loading = false;
        }
      );
    },
    // 跳转按钮
    tapBtn(routerName, row) {

      const query = {
        id: row.id,
        activeName: "first",
        customer_name: row.customer_name,
        search: this.search,
        pageName: "客户列表",
        page:this.page
      };
      if(routerName=='客户信息'){
        this.$router.push({ name: routerName, query });
      }
	   if(routerName=='客户详情'){
      let route = this.$router.resolve({ name: routerName, query });
      window.open(route.href, '_blank');
	   }
    },
    // 导出
    getExport() {
      clientExport1({ ...this.search, search_id:this.$route.query.id,admin_id:this.userInfo.id }).then(res => {
        window.open(res.data.url);
      });
    },
    // 改变表格选中状态
    handleSelectionChange(val) {
      this.idList = val.map(i => {
        return i.id;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.mainColor {
  color: #2dc0a3;
}
.content {
  height: calc(100% - 56px);
  overflow-y: auto;
}
.bgW {
  background: #fff;
  border-radius: 3px;
  padding: 10px;
  margin-bottom: 20px;
}

.el-form-item {
  margin: 5px 20px 3px 0;
}
.accountCon {
  background: #fff;
  padding: 0px 10px 80px;
  .btnBox {
    display: flex;
    justify-content: end;
    // justify-content: space-between;
  }
}
</style>
